import React from 'react';
import { StickyAlert } from './components/sections/StickyAlert';
import { Hero } from './components/sections/Hero';
import { ProblemSection } from './components/sections/ProblemSection';
import { SalesLetter } from './components/sections/SalesLetter';
import { Stats } from './components/sections/Stats';
import { Testimonials } from './components/sections/Testimonials';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 selection:bg-gold selection:text-forest-green" data-id="element-0">
      <StickyAlert data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SalesLetter data-id="element-5" />
        <Stats data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Pricing data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}